
import { LocalStorageManager } from 'legacy/utils/LocalStorageManager';
import { LANGUAGE_KEY } from 'legacy/constants/storageKeys';
import { Language } from 'legacy/types/Language';

export const getCurrentLanguage = (): string => {
  return LocalStorageManager.getItem(LANGUAGE_KEY) || Language.it;
}